import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";

// Spinning wheel
import {ReactSpinner} from 'react-spinning-wheel';
import 'react-spinning-wheel/dist/style.css';

const ImageWithSpinner = (props) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        setImageLoaded(false);
        //console.log("ImageWithSpinner page=" + props.page);
    }, [props.page]);

    return (
        <div>
            {!imageLoaded && <ReactSpinner />}
            <img 
                src={props.src} 
                onLoad={() => setImageLoaded(true)} 
                style={{ display: imageLoaded ? 'block' : 'none', }} 
                alt={props.alt} 
            />
        </div>
    );
};

export default ImageWithSpinner;